export default function Checkbox({
    label,
    name,
    checked = false,
    onChange,
    className = "",
}) {
    return (
        <div className={`flex items-center space-x-2 ${className}`}>
            <input
                id={name}
                name={name}
                type="checkbox"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                className="h-4 w-4 text-primary rounded focus:ring-primary"
            />
            {label && (
                <label
                    htmlFor={name}
                    className="select-none cursor-pointer"
                >
                    {label}
                </label>
            )}
        </div>
    );
}
